

import React, { useEffect } from 'react';
import AOS from 'aos';
import page_json from './config/config.json';
import { Helmet } from 'react-helmet';
import ContactUsButton from './ContactUsButton';
import HeroComponent from './HeroComponent';
import SuccessStoriesList from './SuccessStoriesList';
import config from '../config';

const textDataUrl = `${page_json.page_jsons.Liferay}?v=${config.VERSION}`;
const textDataResponse = await fetch(textDataUrl);
const textData = await textDataResponse.json();

function Liferay() {
	useEffect(() => {
		AOS.init(); 
	}, []);

	return (
    <div data-aos="fade-up" className="liferay">
      <Helmet>
        <meta
          name="description"
          content="Building a robust Digital Experience Platform with Liferay"
        />
        <title>Liferay | Technologies | Engineersmind</title>
      </Helmet>

      <HeroComponent
        isSlider={true}
        isBreadCumb={true}
        breadcrumbs={
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="/">Home </a>
            </li>
            <li className="breadcrumb-item">
              <a href="/Technologies/Salesforce">Technologies </a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Liferay
            </li>
          </ol>
        }
        textData={textData}
        isBannerLogo={false} contactUsBtn={true}
      />

      <div className="container-fluid liferay-sub-header-section">
        <div className="container">
          <div className="row sub-header-row">
            <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12">
              <div className="left-content d-flex flex-column justify-content-center h-100">
                <h4 className="mb-4">{textData.layer11.heading}</h4>
                <p>{textData.layer11.body2}</p>
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12">
              <div className="right-img d-flex justify-content-center">
                <img
                  src={textData.layer11.img}
                  className="img-fluid"
                  alt="industry"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="alliances d-flex flex-column justify-content-center align-items-center mb-5">
        <h1 className="text-white text-center">
          {textData.layer9.heading.text1}
          <span>{textData.layer9.heading.text2}</span>
          {textData.layer9.heading.text3}
        </h1>
        <ContactUsButton
          text={textData.layer9.button.text}
          link="#ContactForm"
          className="light"
        />
      </div>

      <div className="container-fluid matrix liferaypage">
        <div className="container">
          <h1>{textData.layer12.heading}</h1>
          <p>{textData.layer12.heading_details}</p>
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 tabs">
              <div className="tab-content" id="v-pills-tabContent">
                <div
                  className="tab-pane fade show active"
                  id="UA"
                  role="tabpanel"
                  aria-labelledby="unified"
                  data-is-left-layout={true}
                >
                  <div className="tab-content-detailsflex">
                    <div className="tab-content-details col-lg-8 col-md-12 col-sm-12 col-xs-12">
                      <h4>{textData.layer12.details.data1.heading}</h4>
                      <p>{textData.layer12.details.data1.body}</p>
                    </div>
                    <div className="tab-content-img col-lg-4 col-md-12 col-sm-12 col-xs-12">
                      <img
                        src={textData.layer12.details.data1.img}
                        className="d-block w-100"
                        alt="banner-img"
                      />
                    </div>
                  </div>
                </div>

                <div
                  className="tab-pane fade show active"
                  id="SDI"
                  role="tabpanel"
                  aria-labelledby="streamlined"
                >
                  <div className="tab-content-detailsflex">
                    <div className="tab-content-details col-lg-8 col-md-12 col-sm-12 col-xs-12">
                      <h4>{textData.layer12.details.data2.heading}</h4>
                      <p>{textData.layer12.details.data2.body}</p>
                    </div>
                    <div className="tab-content-img col-lg-4 col-md-12 col-sm-12 col-xs-12">
                      <img
                        src={textData.layer12.details.data2.img}
                        className="d-block w-100"
                        alt="banner-img"
                      />
                    </div>
                  </div>
                </div>

                <div
                  className="tab-pane fade show active"
                  id="SDW"
                  role="tabpanel"
                  aria-labelledby="scalabale"
                  data-is-left-layout={true}
                >
                  <div className="tab-content-detailsflex">
                    <div className="tab-content-details col-lg-8 col-md-12 col-sm-12 col-xs-12">
                      <h4>{textData.layer12.details.data3.heading}</h4>
                      <p>{textData.layer12.details.data3.body}</p>
                    </div>
                    <div className="tab-content-img col-lg-4 col-md-12 col-sm-12 col-xs-12">
                      <img
                        src={textData.layer12.details.data3.img}
                        className="d-block w-100"
                        alt="banner-img"
                      />
                    </div>
                  </div>
                </div>

                <div
                  className="tab-pane fade show active"
                  id="DEV"
                  role="tabpanel"
                  aria-labelledby="visualization"
                >
                  <div className="tab-content-detailsflex">
                    <div className="tab-content-details col-lg-8 col-md-12 col-sm-12 col-xs-12">
                      <h4>{textData.layer12.details.data4.heading}</h4>
                      <p>{textData.layer12.details.data4.body}</p>
                    </div>
                    <div className="tab-content-img col-lg-4 col-md-12 col-sm-12 col-xs-12">
                      <img
                        src={textData.layer12.details.data4.img}
                        className="d-block w-100"
                        alt="banner-img"
                      />
                    </div>
                  </div>
                </div>

                <div
                  className="tab-pane fade show active"
                  id="AAML"
                  role="tabpanel"
                  aria-labelledby="advanced"
                  data-is-left-layout={true}
                >
                  <div className="tab-content-detailsflex">
                    <div className="tab-content-details col-lg-8 col-md-12 col-sm-12 col-xs-12">
                      <h4>{textData.layer12.details.data5.heading}</h4>
                      <p>{textData.layer12.details.data5.body}</p>
                    </div>
                    <div className="tab-content-img col-lg-4 col-md-12 col-sm-12 col-xs-12">
                      <img
                        src={textData.layer12.details.data5.img}
                        className="d-block w-100"
                        alt="banner-img"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid globally liferaypage">
        <div className="container">
          <h1>
            <span>{textData.layer13.heading.text1} </span> <br />{" "}
            {textData.layer13.heading.text2}
          </h1>
          <p class="globally-liferaypage-p">
            {textData.layer13.heading_details}
          </p>
        </div>
      </div>
      <div className="py-5 container-fluid">
        <div className="container p-0">
          {textData.layer13.details.map((item, index) => {
            if (index % 2 === 0) {
              return (
                <div className="container-fluid liferaypage experiences">
                  <div className="row">
                    <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                      <div className="boosting">
                        <div class="boostingtxtnontitle">
                          <h5>{item.heading}</h5>
                        </div>
                        <p>{item.body}</p>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                      <div className="boosting-img">
                        <img
                          src={item.img}
                          className="d-block w-100"
                          alt="banner-img"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              );
            } else {
              return (
                <div className="container-fluid liferaypage experiences">
                  <div className="row">
                    <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                      <div className="boosting-img">
                        <img
                          src={item.img}
                          className="d-block w-100"
                          alt="banner-img"
                        />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                      <div className="boosting">
                        <div class="boostingtxtnontitle">
                          <h5>{item.heading}</h5>
                        </div>
                        <p>{item.body}</p>
                      </div>
                    </div>
                  </div>
                </div>
              );
            }
          })}
        </div>
      </div>
      <SuccessStoriesList StoriesList={textData.storiesList} />
    </div>
  );
}

export default Liferay;